import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledTypography = styled(Typography)({
  textAlign: 'center',
  marginTop: '1rem',
  fontSize: 'large',
  fontWeight: 'bold',
});

export default StyledTypography;